import { Box, Grid, Typography } from '@mui/material';
import styles from "../../Styles/ComponentStyles/RegisterProfile/RegisterProfile.module.scss";
import { useNavigate } from 'react-router-dom';
import { ProfileContext, ProfileContextPayload } from '../../Context/ProfileDetailsContext';
import { useContext } from 'react';

const RegisterProfile = () => {
    const { setFlagOpenRegisterProfileDialog } = useContext(ProfileContext) as ProfileContextPayload;

    const registerProfileOptions = [
        {
            name: 'New IUL',
            description: 'Indexed Universal Life strategies for protection and growth.',
            navigation: "/profile/newProfile/iul",
            showBeta: false,
        },
        {
            name: 'New Annuity - Roth Conversion',
            description: 'Analyze tax implications and conversion benefits.',
            navigation: "/profile/newProfile/annuityRothConversion",
            showBeta: true,
        },
        {
            name: 'New Annuity - Income',
            description: 'Plan for guaranteed lifetime income streams.',
            navigation: "/profile/newProfile/annuityIncome",
            showBeta: true,
        },
        {
            name: 'New Annuity - Accumulation',
            description: 'Optimize asset growth for long-term savings goals.',
            navigation: "/profile/newProfile/annuityAccumulation",
            showBeta: true,
        }
    ];

    const navigate = useNavigate();

    return (
        <Box className={styles.optionsList}>
            {registerProfileOptions.map((item, index) => (
                <Box
                    key={index}
                    className={styles.optionCard}
                    onClick={() => {
                        navigate(item.navigation);
                        setFlagOpenRegisterProfileDialog(false);
                    }}
                >
                    {item.showBeta && (
                        <Typography
                            component="span"
                            className={styles.betaTag}
                        >
                            Beta
                        </Typography>
                    )}
                    <Typography component="span" className={styles.optionTitle}>
                        {item.name}
                    </Typography>
                    <Typography component="span" className={styles.optionDescription}>
                        {item.description}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default RegisterProfile;
